<header class="header-page row">
  <section class="col-sm-12 col-md-7 col-xl-7 px-0">
    <h1 class="header__page__content__title">
      Solicitações de Benefício
    </h1>
  </section>
  <section class="col-sm-12 col-md-5 col-xl-5 px-1 float-right px-sm-0">
    <button type="submit" class="btn btn-outline-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 float-right"
      [routerLink]="['/solicitacao-beneficio']">
      Voltar
    </button>
  </section>
</header>
<ng-template #naoPossuiSolicitacao>
  <aviso [textoAviso]="'Não localizamos solicitações de benefício!'"></aviso>
</ng-template>
<main class="col-sm-12 col-xl-12 main__content"
  *ngIf="listaSolicitacoes && listaSolicitacoes.items.length > 0 else naoPossuiSolicitacao">
  <section class="content__header__page">
    <h3>
      Minhas Solicitações de Benefício
    </h3>
    <filtro-dados [pageItens]="5" [totalItens]="listaSolicitacoes.totalItems"
      (changeQuantidade)="onChangeQuantidadeItens($event)"
      *ngIf="listaSolicitacoes && listaSolicitacoes.items?.length > 0">
    </filtro-dados>
  </section>
  <section class="content__main">
    <div class="d-flex content__header__table">
      <div class="col-xl-4">Data/Hora solicitação</div>
      <div class="col-xl-4">Tipo de Benefício</div>
      <div class="col-xl-3">Situação</div>
      <div class="col-xl-1 text-center">Ações</div>
    </div>
    <div class="table__card" *ngFor="let solicitacao of listaSolicitacoes.items">
      <div class="col-xl-4">{{(solicitacao.solicitation.requestDate | date:'dd/MM/yyyy') || ' - '}}</div>
      <div class="col-xl-4">{{solicitacao.benefitType.description}}</div>
      <div class="col-xl-3">
        <status [status]="solicitacao.status.description.trim()">
        </status>
      </div>
      <div class="col-xl-1 fa-icon icone-acao-form text-center">
        <fa-icon [icon]="faEye" (click)="detalhesBeneficio(solicitacao)"></fa-icon>
      </div>
    </div>
  </section>
  <section class="col-12 footer__content">
    <paginacao [currentPage]="1" [collectionSize]="listaSolicitacoes?.totalItems" [pageSize]="filter?.ItemsPerPage"
      (changeNumber)="onChangePagination($event)">
    </paginacao>
  </section>
</main>
<footer>
  <blockquote class="content-aviso-solicitacao-beneficio mt-4">
    <h4 class="desc-title mx-0 mb-2">AVISO IMPORTANTE!</h4>
    <section class="mx-2">
      <p class="desc-info">Ao solicitar um benefício você concordou que para manter a continuidade do(s) benefício(s)
        solicitado(s) acima:
      </p>
      <ul class="footer__content__notas">
        <li>O prazo para análise da solicitação de benefício é de 30 (trinta) dias.
        </li>
        <li>O retorno de informações ocorrerá no e-mail constante em seu cadastro.
        </li>
        <li>O pedido poderá ser acompanhado no “Status” da situação dessa solicitação.
        </li>
        <li>Eventuais dúvidas poderão ser sanadas pelo e-mail previdencia@fcopel.org.br.</li>
      </ul>
      <p class="desc-info">Demais informações relacionadas apenas a solicitação de aposentadoria:
      </p>
      <ul class="footer__content__notas">
        <li>Sua análise de pagamento estará disponível para consulta no portal da Fundação Copel. Ela sempre estará
          disponível por volta do dia 20 de cada mês. Problema de acesso ou cadastro de senha, entre em contato com a
          central de atendimento através do e-mail fundacao@fcopel.org.br;
        </li>
        <li>Os pagamentos mensais estarão disponíveis no dia 25 de cada mês ou no próximo dia útil, caso essa data caia
          em
          domingos ou feriados;
        </li>
        <li>Os participantes que migraram do Plano Unificado (básico/complementar) em 1998 para o Plano III terão duas
          verbas de benefício bruto: uma correspondente ao Plano III e a outra referente ao benefício do plano anterior
          (BSA);
        </li>
        <li>Seu benefício será corrigido no mês de novembro pela variação do INPC;
        </li>
        <li>Em dezembro há o 13º benefício, chamado de Abono, com adiantamento automático de 35% no mês de julho. Caso
          não
          tenha interesse em receber o adiantamento, é só enviar um e-mail para previdencia@fcopel.org.br solicitando o
          cancelamento;
        </li>
        <li>Em sua análise, além das verbas de benefícios (proventos), haverá as verbas de desconto, de acordo com a
          característica de cada plano. Destacamos as principais:
          <ul class="footer__content__notas">
            <li>5001 - Contribuição previdenciária Plano Unificado: desconto que varia entre 3% e 13%, de acordo com o
              valor do benefício e o plano de origem (Básico ou Complementar).
            </li>
            <li>5027 - Taxa administrativa do Plano III: desconto de sobre o benefício do Plano III.
            </li>
            <li>5004 - Imposto de renda: desconto de IR referente à tabela progressiva.
            </li>
            <li>5017 - Imposto de renda: desconto de IR referente à tabela regressiva.
            </li>
            <li>1901 e 1902 - Compensação das contribuições 89/95 - IN1343: para o participante que contribuiu entre
              1989
              e 1995 e se aposentou a partir de 01/2013, a Fundação Copel procede com a dedução mensal de imposto de
              renda em concordância com a Instrução Normativa 1.343 de 05 de abril de 2013. Na prática, a verba 1902
              entra como dedução da base de imposto de renda e a 1901 como contrapartida, para não alterar o valor do
              benefício.
              Importante destacar que apenas os rendimentos tributáveis referentes às contribuições de 01/1989 a 12/1995
              são contemplados por esta Instrução. Sendo assim, somente a verba 1000, referente ao Plano Unificado, é
              impactada.
              A dedução de imposto de renda ocorrerá até o exaurimento do total das contribuições acima informadas.
            </li>
          </ul>
        </li>
        <li>Demais verbas como mensalidade do plano de saúde, empréstimo, Plano Pecúlio, seguro de vida e clubes, também
          são descontadas se houverem. Qualquer alteração referente a seguro de vida ou clube deve ser feita diretamente
          com eles.
        </li>
      </ul>
    </section>
  </blockquote>
</footer>